/**
=========================================================
* Material Dashboard 3 PRO React - v2.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function ParameterCard({ label, value, color, textColor = "white" }) {
  return (
    <Card
      sx={{
        backgroundColor: color,
        borderRadius: "4px",
        overflow: "hidden",
        minWidth: "120px",
        flex: 1,
      }}
    >
      <MDBox
        sx={{
          padding: "1.5rem",
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100px",
        }}
      >
        <MDTypography
          variant="caption"
          color={textColor}
          sx={{
            fontSize: "0.75rem",
            display: "block",
            mb: 1,
            fontWeight: "medium",
            textTransform: "uppercase",
          }}
        >
          {label}
        </MDTypography>
        <MDTypography
          variant="h2"
          fontWeight="bold"
          color={textColor}
          sx={{
            fontSize: "3.5rem",
            lineHeight: 1.2,
          }}
        >
          {value}
        </MDTypography>
      </MDBox>
    </Card>
  );
}

// Typechecking props for the ParameterCard
ParameterCard.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  color: PropTypes.string.isRequired,
  textColor: PropTypes.string,
};

export default ParameterCard;

